import { FILTERS_COMPONENT_BLOOMING } from '@features/regional-overview/domain/tests-id.constants';
import {
  RegionalOverviewFilterType,
  type FilterValue,
  type RegionalOverviewFilterType as FilterTypeAlias
} from '@features/regional-overview/regional-overview.models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RangePickerFilterComponent from '../../components/range-picker-filter/range-picker-filter.component';
import { useFiltersStore } from '../../filters.store';

interface BloomingSectionProps {
  defaultExpanded?: boolean;
}

const BloomingSection = ({ defaultExpanded }: BloomingSectionProps) => {
  const [t] = useTranslation();
  const selectedValue = useFiltersStore(state => state.values[RegionalOverviewFilterType.BLOOMING]);
  const setValue = useFiltersStore(state => state.setValue);

  const handleFilterChanged = useCallback(
    (_filter: FilterTypeAlias, value: FilterValue) => {
      setValue(RegionalOverviewFilterType.BLOOMING, value);
    },
    [setValue]
  );

  return (
    <RangePickerFilterComponent
      filter={RegionalOverviewFilterType.BLOOMING}
      selectedValue={selectedValue}
      onFilterChanged={handleFilterChanged}
      title={t('pages.regional_overview.regional_mycotoxin.blooming')}
      defaultExpanded={defaultExpanded}
      dataTestID={FILTERS_COMPONENT_BLOOMING}
    />
  );
};

export default BloomingSection;
